// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"58cf0caeaf19407e0741","966":"9ad35a5d0da0269c48da"}[chunkId] + ".js";
};